<template>
  <CreditCardsComponent />
</template>

<script lang="ts">
import CreditCardsComponent from "@/components/CreditCards/CreditCards.vue";
import { defineComponent } from "vue";

const componentName = "CreditCardRoute";

export default defineComponent({
  name: componentName,
  components: { CreditCardsComponent },
});
</script>
